var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.documento || _vm.esImagen)?_c('img',{attrs:{"src":_vm.srcImg},on:{"click":function($event){return _vm.Documento.download(_vm.documento)}}}):_c('img',{attrs:{"src":require("./../static/img/download-from-cloud.png")},on:{"click":function($event){return _vm.Documento.download(_vm.documento)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }